import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
  UserSubOrderV2EnrichedStatusEnum,
} from '@redteclab/api/clients/bully'

import { userSubOrderAccessorIsCancellationRequested } from './userSubOrderAccessor'

type SubOrderDocumentsSelfServiceAvailability =
  'disabled' | 'enabled' | 'hidden'

export const subOrderStatusAccessorGetDocumentsSelfServiceAvailability = (
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
): SubOrderDocumentsSelfServiceAvailability => {
  if (userSubOrderAccessorIsCancellationRequested(subOrder)) {
    return 'hidden'
  }

  switch (subOrder.enrichedStatus) {
    case UserSubOrderV2EnrichedStatusEnum.Canceled:
    case UserSubOrderV2EnrichedStatusEnum.CancelRequested:
    case UserSubOrderV2EnrichedStatusEnum.New:
    case UserSubOrderV2EnrichedStatusEnum.WaitingForPrepayment: {
      return 'hidden'
    }
    case UserSubOrderV2EnrichedStatusEnum.Closed:
    case UserSubOrderV2EnrichedStatusEnum.Completed:
    case UserSubOrderV2EnrichedStatusEnum.Dispatched:
    case UserSubOrderV2EnrichedStatusEnum.ReadyForPickup: {
      return 'enabled'
    }
    case UserSubOrderV2EnrichedStatusEnum.Processing: {
      return 'disabled'
    }
    default: {
      return 'hidden'
    }
  }
}
